import React from 'react';
import Loading from '../../Loading';
// @ts-ignore
import styles from './FullPageLoading.module.scss';

interface IFullPageLoading {
	isAbsolute?: boolean;
}

const FullPageLoading: React.FC<IFullPageLoading> = ({ isAbsolute }) => (
	<div id='pageLoader'>
		<div className='page-loader-wrapper'>
			<div className='w-100'>
				<Loading absolute={isAbsolute} />
			</div>
		</div>
	</div>
);

export default FullPageLoading;
